import React from 'react';
import { CellProps } from 'react-table';
import { Checkbox } from '../Checkbox';
import { TableColumn } from './types';

export const getSelectColumn = <T extends object>(showSelection?: boolean) => {
  if (!showSelection) return [] as TableColumn<T>[];
  return [
    {
      id: 'selection',
      Header: (header) => (
        <Checkbox
          {...header.getToggleAllRowsSelectedProps()}
          onClick={(e) => e.stopPropagation()}
          marginLeft={0.5}
        />
      ),
      Cell: ({ row }: CellProps<T>) => {
        return (
          <Checkbox {...row.getToggleRowSelectedProps()} onClick={(e) => e.stopPropagation()} />
        );
      },
      minWidth: 20,
      width: 20,
    },
  ] as TableColumn<T>[];
};
